/**
 * Configuration centralisée des constantes de l'application
 * Toutes les valeurs en dur sont remplacées par des variables d'environnement
 */

// Configuration des couleurs par défaut
export const DEFAULT_COLORS = {
  ACCOUNT: process.env.REACT_APP_DEFAULT_ACCOUNT_COLOR || '#3B82F6',
  CATEGORY: process.env.REACT_APP_DEFAULT_CATEGORY_COLOR || '#00E676',
  UNKNOWN: '#000000',
};

// Palette de couleurs prédéfinies
export const COLOR_PALETTE = [
  '#3B82F6', '#EF4444', '#10B981', '#F59E0B', 
  '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16'
];

// Configuration des emails
export const EMAIL_CONFIG = {
  CONTACT: process.env.REACT_APP_CONTACT_EMAIL || 'contact@suivifinance.com',
  ADMIN: process.env.REACT_APP_ADMIN_EMAIL || 'ccc.adam@gmail.com',
  PLACEHOLDER: 'votre@email.com',
};

// Configuration des fréquences
export const FREQUENCIES = process.env.REACT_APP_FREQUENCIES 
  ? process.env.REACT_APP_FREQUENCIES.split(',') as Array<'quotidienne' | 'hebdomadaire' | 'mensuelle' | 'trimestrielle' | 'annuelle'>
  : ['quotidienne', 'hebdomadaire', 'mensuelle', 'trimestrielle', 'annuelle'];

// Labels des fréquences
export const FREQUENCY_LABELS = {
  quotidienne: 'Quotidienne',
  hebdomadaire: 'Hebdomadaire',
  mensuelle: 'Mensuelle',
  trimestrielle: 'Trimestrielle',
  annuelle: 'Annuelle',
};

// Configuration des types de comptes
export const ACCOUNT_TYPES = process.env.REACT_APP_ACCOUNT_TYPES
  ? process.env.REACT_APP_ACCOUNT_TYPES.split(',') as Array<'compte_courant' | 'epargne' | 'credit' | 'autre'>
  : ['compte_courant', 'epargne', 'credit', 'autre'];

// Configuration des types de catégories
export const CATEGORY_TYPES = process.env.REACT_APP_CATEGORY_TYPES
  ? process.env.REACT_APP_CATEGORY_TYPES.split(',') as Array<'depense' | 'revenu'>
  : ['depense', 'revenu'];

// Configuration des jours de la semaine
export const WEEKDAYS = [
  { value: 0, label: 'Dimanche' },
  { value: 1, label: 'Lundi' },
  { value: 2, label: 'Mardi' },
  { value: 3, label: 'Mercredi' },
  { value: 4, label: 'Jeudi' },
  { value: 5, label: 'Vendredi' },
  { value: 6, label: 'Samedi' },
];

// Configuration des mois
export const MONTHS = [
  { value: 0, label: 'Janvier' },
  { value: 1, label: 'Février' },
  { value: 2, label: 'Mars' },
  { value: 3, label: 'Avril' },
  { value: 4, label: 'Mai' },
  { value: 5, label: 'Juin' },
  { value: 6, label: 'Juillet' },
  { value: 7, label: 'Août' },
  { value: 8, label: 'Septembre' },
  { value: 9, label: 'Octobre' },
  { value: 10, label: 'Novembre' },
  { value: 11, label: 'Décembre' },
];

// Configuration des couleurs pour les catégories
export const CATEGORY_COLORS = [
  '#00E676', // vert
  '#2196F3', // bleu
  '#FF9800', // orange
  '#E91E63', // rose
  '#9C27B0', // violet
  '#FFEB3B', // jaune
  '#F44336', // rouge
  '#3B82F6', // bleu moderne
  '#10B981', // vert moderne
  '#F59E0B', // orange moderne
  '#EC4899', // rose moderne
  '#8B5CF6', // violet moderne
];

// Fonction utilitaire pour vérifier si un utilisateur est admin
// DEPRECATED — utiliser useUserRole().isAdmin
export const isAdminUser = (email: string | undefined): boolean => {
  return email === EMAIL_CONFIG.ADMIN;
};

// Fonction utilitaire pour obtenir le label d'une fréquence
export const getFrequencyLabel = (frequency: string): string => {
  return FREQUENCY_LABELS[frequency as keyof typeof FREQUENCY_LABELS] || frequency;
};
